import { forwardRef, HTMLAttributes } from "react";
import { cn } from "./utils";

interface CollapseProps extends HTMLAttributes<HTMLDivElement> {
  isOpen?: boolean;
}

const Collapse = forwardRef<HTMLDivElement, CollapseProps>(
  ({ className, isOpen = false, children, ...props }, ref) => {
    if (!isOpen) return null;

    return (
      <div ref={ref} className={cn("al-transition-all", className)} {...props}>
        {children}
      </div>
    );
  },
);

Collapse.displayName = "Collapse";

export default Collapse;
